import { render, staticRenderFns } from "./QRCodeGenerator.vue?vue&type=template&id=5489af94&scoped=true"
import script from "./QRCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QRCodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./QRCodeGenerator.vue?vue&type=style&index=0&id=5489af94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489af94",
  null
  
)

export default component.exports